import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import { getPerformance } from "firebase/performance";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Remote Config
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.fetchTimeoutMillis = 30000;
remoteConfig.settings.minimumFetchIntervalMillis = 300000; // (5 minutes)
// minimumFetchIntervalMillis: cache time before needed to update data
// The default setting is 3600000 (1 hour)

const perf = getPerformance(app);

export { remoteConfig, perf };
